import React from "react";
import { connect } from "react-redux";
import GuestAccountModal from "../GuestAccountModal/GuestAccountModal.tsx";
import FreeTrialModal from "../SuscriptionModal/FreeTrialModal.tsx";
import SuscriptionModal from "../SuscriptionModal/SuscriptionModalNew.tsx";
import { getSubscriptionModalVariant } from "../../../utils/subscriptionModalSelector.ts";

interface SubscriptionModalRouterProps {
  isOpen: boolean;
  variant: "guest" | "free_trial" | "subscription";
}

const SubscriptionModalRouter: React.FC<SubscriptionModalRouterProps> = ({
  isOpen,
  variant,
}) => {
  if (!isOpen) return null;

  switch (variant) {
    case "guest":
      return <GuestAccountModal />;
    case "free_trial":
      return <FreeTrialModal />;
    case "subscription":
      return <SuscriptionModal />;
    default:
      return <SuscriptionModal />;
  }
};

const mapStateToProps = (state: {
  general: {
    showSuscriptionModal: boolean;
    userData?: { username?: string; free_trial?: { status?: string } };
  };
}) => {
  const { showSuscriptionModal, userData } = state.general;
  const isGuestAccount = userData?.username === "invited@edify.la";
  const isFreeTrialAvailable = userData?.free_trial?.status === "no-activated";
  return {
    isOpen: showSuscriptionModal,
    variant: getSubscriptionModalVariant(isGuestAccount, isFreeTrialAvailable),
  };
};

export default connect(mapStateToProps)(SubscriptionModalRouter);
